(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[765],{

/***/ 3117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/issues",
      function () {
        return __webpack_require__(6576);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8172);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Container_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Container_module_sass__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
Container.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any)
};


/***/ }),

/***/ 5137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Container_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7158);
/* harmony import */ var _SearchInput_SearchInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4837);
/* harmony import */ var _Header_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7342);
/* harmony import */ var _Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Header_module_sass__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable @next/next/no-img-element */ 





var Header = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var headerClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().header), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().headerOpen) : "");
    var menuClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menu), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menuOpen) : "");
    var burgerClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().burgerIcon), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().open) : "");
    var closeMenu = function() {
        return setIsMenuOpen(false);
    };
    var toggleMenu = function(e) {
        e.preventDefault();
        setIsMenuOpen(function(isOpen) {
            return !isOpen;
        });
    };
    var menuItems = [
        {
            href: "/diary",
            title: "Cake Diary"
        },
        {
            href: "/issues",
            title: "Issues"
        },
        {
            href: "https://vimeo.com/user10253399",
            isExternal: true,
            title: "Cake TV"
        },
        {
            href: "/buy",
            isExternal: true,
            title: "Buy Print + Digital!"
        },
        {
            href: "/merch",
            isExternal: true,
            title: "Merch"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: headerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().logo),
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        onClick: closeMenu,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: "Cake Magazine"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                    className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menuBar),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: burgerClass,
                            onClick: toggleMenu,
                            children: [
                                "Menu",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: menuClass,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    menuItems.map(function(param) {
                                        var href = param.href, isExternal = param.isExternal, title = param.title;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: isExternal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: href,
                                                onClick: closeMenu,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: title
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: href,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    onClick: closeMenu,
                                                    children: title
                                                })
                                            })
                                        }, href);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().institutionalLinks),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/about",
                                                children: "About us"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/contact",
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/cookie-policy",
                                                children: "Cookie Policy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().search),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchInput_SearchInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().socialIcons),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Instagram",
                                                href: "https://www.instagram.com/cakemagazine",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow @cakemagazine on Instagram",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/instagram.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Facebook",
                                                href: "https://www.fb.com/cakemag",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Facebook",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/facebook.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Vimeo",
                                                href: "https://vimeo.com/user10253399",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Vimeo",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/vimeo.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Tumblr",
                                                href: "https://cake-mag.tumblr.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Tumblr",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/tumblr.svg"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 4837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2267);
/* harmony import */ var _SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var SearchInput = function(param) {
    var defaultValue = param.defaultValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2___default().searchContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            action: "/search",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    autoCapitalize: "off",
                    autoComplete: "off",
                    defaultValue: defaultValue,
                    name: "q",
                    placeholder: "Search",
                    required: true,
                    type: "search"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "submit",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "Search",
                        height: 20,
                        width: 20,
                        src: "/icons/search.svg"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchInput);
SearchInput.propTypes = {
    defaultValue: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};


/***/ }),

/***/ 6576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Issue; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Container/Container.js
var Container = __webpack_require__(7158);
// EXTERNAL MODULE: ./components/Header/Header.js
var Header = __webpack_require__(5137);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/IssueItem/IssueItem.module.sass
var IssueItem_module = __webpack_require__(2374);
var IssueItem_module_default = /*#__PURE__*/__webpack_require__.n(IssueItem_module);
;// CONCATENATED MODULE: ./components/IssueItem/IssueItem.js





var IssueItem = function(param) {
    var categoriesExtra = param.categoriesExtra, count = param.count, name = param.name, posts = param.posts, slug = param.slug;
    var ref, ref1, ref2;
    var featuredImageUrl = categoriesExtra === null || categoriesExtra === void 0 ? void 0 : (ref = categoriesExtra.featureimage) === null || ref === void 0 ? void 0 : ref.sourceUrl;
    var issueLink = count === 1 ? posts === null || posts === void 0 ? void 0 : (ref1 = posts.nodes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.slug : "/issues/".concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: issueLink,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (IssueItem_module_default()).issueItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (IssueItem_module_default()).overlay,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: name
                        })
                    }),
                    featuredImageUrl && // eslint-disable-next-line @next/next/no-img-element
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (IssueItem_module_default()).image,
                        alt: name,
                        src: featuredImageUrl
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var IssueItem_IssueItem = (IssueItem);
IssueItem.propTypes = {
    categoriesExtra: (prop_types_default()).object,
    count: (prop_types_default()).number,
    name: (prop_types_default()).string,
    posts: (prop_types_default()).object,
    slug: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/IssueList/IssueList.module.sass
var IssueList_module = __webpack_require__(5673);
var IssueList_module_default = /*#__PURE__*/__webpack_require__.n(IssueList_module);
;// CONCATENATED MODULE: ./components/IssueList/IssueList.js






var IssueList = function(param) {
    var list = param.list;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("section", {
        className: (IssueList_module_default()).issueList,
        children: list === null || list === void 0 ? void 0 : list.map(function(issue) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (IssueList_module_default()).postItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IssueItem_IssueItem, (0,_object_spread/* default */.Z)({}, issue))
            }, issue.slug);
        })
    });
};
/* harmony default export */ var IssueList_IssueList = (IssueList);
IssueList.propTypes = {
    list: (prop_types_default()).array,
    pageInfo: prop_types_default().shape({
        hasNextPage: (prop_types_default()).bool,
        endCursor: (prop_types_default()).string
    })
};

;// CONCATENATED MODULE: ./pages/issues/index.js







var __N_SSG = true;
function Issue(param) {
    var issues = param.issues;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Issues | cake-mag.com"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Cake Issues"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IssueList_IssueList, {
                            list: issues
                        })
                    ]
                })
            })
        ]
    });
}
Issue.propTypes = {
    issues: (prop_types_default()).array
};


/***/ }),

/***/ 8172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__jvqQM"};

/***/ }),

/***/ 7342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__c7sEG","headerOpen":"Header_headerOpen__1eT1g","shadow":"Header_shadow__vX_rV","burgerIcon":"Header_burgerIcon__bMu2L","open":"Header_open__5zsqk","menu":"Header_menu__oC7Qi","menuOpen":"Header_menuOpen__xsvrr","search":"Header_search__D2K1q","institutionalLinks":"Header_institutionalLinks__aqwUq","socialIcons":"Header_socialIcons__GHhSJ"};

/***/ }),

/***/ 2374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"issueItem":"IssueItem_issueItem__ph2HV","image":"IssueItem_image__Xqkma","overlay":"IssueItem_overlay__EysDT"};

/***/ }),

/***/ 5673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"issueList":"IssueList_issueList__vpa4R"};

/***/ }),

/***/ 2267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchInput_searchContainer__KqjXj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(3117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);